import * as Sentry from "@sentry/react";

export const CAT_ERROR_TRACKING = "error_tracking";
export const SERVICE_SENTRY = "sentry" as const;

export function updateSentryConsent(CookieConsent: {
  acceptedService: (service: string, category: string) => boolean;
  acceptedCategory: (category: string) => boolean;
}) {
  if (!CookieConsent.acceptedService(SERVICE_SENTRY, CAT_ERROR_TRACKING)) {
    return;
  }

  const client = Sentry.getClient();

  if (client?.getIntegrationByName("Replay")) return;

  client?.addIntegration(
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    })
  );
}
